import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './style.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import GamesPage from './Games';
import GamePage from './Game';
import AdminLogin from './AdminLogin';
import GameLoginPage from './GameLogin';
import DefaultLogin from './DefaultLogin';
import SettingsPage from './Settings';
import AuthProvider from './AuthProvider';
import PrivateRoute from './PrivateRoute';
import RegistrationForm from './RegistrationForm';
import UsersPage from './UsersPage';
import i18n from './i18n';

const locale = sessionStorage.getItem('locale') || 'et';
i18n.changeLanguage(locale);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<DefaultLogin />} />
          <Route path="/jumal" element={<AdminLogin />} />
          <Route path="/games/:id/login" element={<GameLoginPage />} />
          <Route element={<PrivateRoute />}>
            <Route path="/games" element={<GamesPage />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path="/games/:id" element={<GamePage />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path="/users" element={<UsersPage />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="/register/:id" element={<RegistrationForm />} />
          <Route path="*" element={<Navigate to={"/login"} />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
